import React, { useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';


const DashboardSideBar = () => {
    const location = useLocation();
    let page = location.pathname.split('/').pop();
    const [activeSection, setActiveSection] = useState(page ? page : '');
    return (
        <>
            <div className="dashboard">
                <div className="side-nav">
                    <ul className="ul">
                        <li className={activeSection === 'dashboard' && 'activeli'}><NavLink to={`/dashboard`} onClick={() => setActiveSection('dashboard')}>My Posts</NavLink></li>
                        <li className={activeSection === 'my-donations' && 'activeli'}><NavLink to={`/dashboard/my-donations`} onClick={() => setActiveSection('my-donations')}> My Donations</NavLink></li>
                    </ul>
                </div>
            </div>
        </>
    );
};

export default DashboardSideBar;